import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'

import { client } from '@/proxy/client'

export const SELLER_PAYMENT_METHODS = gql`
  query sellerPaymentMethods {
    seller {
      shop {
        paymentMethods {
          type
        }
      }
    }
  }
`

export const SELLER_PAYMENT_METHODS_KEY = 'useSellerPaymentMethods'

export const useSellerPaymentMethods = () =>
  useQuery({
    queryKey: [SELLER_PAYMENT_METHODS_KEY],
    queryFn: variables => client.request(SELLER_PAYMENT_METHODS, variables),
  })
